import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import ActiveFilters from './ActiveFilters'

function ActiveFiltersBar(props) {
  function handleFiltersChange(key, value) {
    props.onFiltersChange({
      ...props.filters,
      [key]: value,
    })
  }

  function checkMultiSelect(relatedField, arrayToCheck, arrayToEdit, target) {
    const convertedItem = arrayToCheck.find(item => item.label === target)

    if (convertedItem) {
      handleFiltersChange(relatedField, arrayToEdit.filter(value => value !== convertedItem.value))
      return true
    }
    return false
  }

  function handleTagClick(target) {
    if (target === 'Open for hire') {
      handleFiltersChange('isOpenForHire', false)
    } else {
      if (props.filters.keywords.includes(target)) {
        let keywords = []

        if (props.filters.searchFilter !== 'location') {
          keywords = props.filters.keywords.split(' ').filter(keyword => keyword !== target
            && keyword !== ' '
            && keyword !== '')
        }

        handleFiltersChange('keywords', keywords.join(' '))
        return
      }

      if (!checkMultiSelect('software', props.availableSoftwareOptions, props.filters.software, target)) {
        checkMultiSelect('skills', props.availableSkillOptions, props.filters.skills, target)
      }
    }
  }

  let tags = []
  let keywords = []
  const skills = props.filters.skills.map(skill => {
    return props.availableSkillOptions.find(item => item.value === skill).label
  })
  const softItems = props.filters.software.map(softItem => {
    return props.availableSoftwareOptions.find(item => item.value === softItem).label
  })

  if (props.filters.keywords) {
    if (props.filters.searchFilter !== 'location') {
      keywords = props.filters.keywords.split(' ').filter(keyword => keyword !== ' ' || keyword !== '')
      keywords = [...new Set(keywords)]
    } else {
      keywords.push(props.filters.keywords)
    }
  }

  tags = [...tags, ...skills, ...softItems, ...keywords]

  if (props.filters.isOpenForHire) {
    tags.push('Open for hire')
  }

  return (
    <Fragment>
      {tags.length > 0 && (
        <div className="job-list-item__row active-filters__row">
          <ActiveFilters
            tags={tags}
            redirectTagEvent={(tag) => { handleTagClick(tag) }}
          />
        </div>
      )}
    </Fragment>
  )
}

ActiveFiltersBar.propTypes = {
  onFiltersChange: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  availableSkillOptions: PropTypes.array.isRequired,
  availableSoftwareOptions: PropTypes.array.isRequired,
}

export default ActiveFiltersBar
